module.exports = __webpack_public_path__ + "img/blueEye.95229267.svg";